import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Switch from 'flarum/common/components/Switch';
import Link from 'flarum/common/components/Link';
export default class AcceptTermsModal extends FormModal {
  isRead = false;
  className() {
    return 'Modal--small AcceptTermsModal';
  }
  title() {
    return app.translator.trans('floxum-payments.forum.accept-terms-modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, m("div", {
      className: "Form-group"
    }, m(Switch, {
      onchange: value => this.isRead = value,
      state: this.isRead
    }, app.translator.trans('floxum-payments.forum.accept-terms-modal.accept_label', {
      link: m(Link, {
        href: app.forum.blomstraLinkToTerms()
      })
    }))), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--block Button--primary",
      type: "submit",
      loading: this.loading,
      disabled: !this.isRead
    }, app.translator.trans('floxum-payments.forum.accept-terms-modal.continue_button')))));
  }
  onsubmit(e) {
    e.preventDefault();
    super.onsubmit(e);
    this.loading = true;
    this.attrs.onsubmit();
  }
}
flarum.reg.add('floxum-payments', 'forum/Checkout/AcceptTermsModal', AcceptTermsModal);